import { TFunction } from 'react-i18next';
import { ITEMS_PER_PAGE } from '../constants';

export const getItemsPerPageOptions = (t: TFunction<'billing-history'>) => {
  return ITEMS_PER_PAGE.map((itemsPerPage) => ({
    label: t('items_per_page', { items: itemsPerPage }),
    value: itemsPerPage,
  }));
};
